import { currentWellDetailsSelector, currentWellSelector, wellViewsOpenAtom } from 'atoms'
import {  useSetRecoilState } from 'recoil'

import { injectTermToSearchHistory } from 'components/common/SearchBarWithRecent'
import { useCallback } from 'react'
import useInnovaAuth from 'components/common/hooks/useInnovaAuth'
import { useNavigate } from 'react-router-dom'
import useUserDatabaseAccess from 'components/common/hooks/useUserDatabaseAccess'
import useWellListContext from 'components/common/hooks/WellListContext'

const useWellListNavigate = () => {
  const navigate = useNavigate()
  const setCurrentWell = useSetRecoilState(currentWellSelector)
  const setCurrentWellDetails = useSetRecoilState(currentWellDetailsSelector)
  const setWellsListOpen = useSetRecoilState(wellViewsOpenAtom)
  const { hasMultiDbAccess, setAccessDatabase } = useUserDatabaseAccess(false)
  const { getDatabaseOrg, saveDatabaseOrg, changeUserRole } = useInnovaAuth()
  const { getWell } = useWellListContext()

  const navigateToWellPage = useCallback(
    async ({ event, well, url = '/well-pages/well-page', inject = true } = {}) => {
      if (!well || !well.actualWell) return
      if (!well.organization) {
        well = getWell({ actualWell: well.actualWell, organization: getDatabaseOrg() })
      }

      event?.stopPropagation?.()

      let dbChanged = false
      if (hasMultiDbAccess() && getDatabaseOrg() !== well.organization) {
        dbChanged = true
        setAccessDatabase(well.organization)
      }

      setCurrentWell({
        wellName: well.actualWell,
        organization: well.organization,
      })

      setCurrentWellDetails({
        actualWell: well.actualWell,
        wellStatus: well.wellStatus,
        operator: well.operator,
        rig: well.rig,
        jobNum: well.jobNum,
        lat: well.latitude,
        lng: well.longitude,
        org: well?.organization,
      })

      changeUserRole(well.organization)
      saveDatabaseOrg(well.organization)

      if (inject) {
        injectTermToSearchHistory('wellListRecentSearches', {
          icon: 'fa6-solid:oil-well',
          term: well.actualWell,
        })
      }

      setWellsListOpen(true)

      if (url) {
        navigate(url)
        setWellsListOpen(true)
      }

      if (dbChanged) {
        window.location.reload()
      }
    },
    [
      hasMultiDbAccess,
      getDatabaseOrg,
      setAccessDatabase,
      setCurrentWell,
      setCurrentWellDetails,
      setWellsListOpen,
      navigate,
      getWell,
      saveDatabaseOrg,
      changeUserRole,
    ],
  )

  return { navigateToWellPage }
}

export default useWellListNavigate
